var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisabledFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.83203H4",
    stroke: "#EDF0F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.1641H6.5",
    stroke: "#EDF0F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.1641L16.5 12.1641",
    stroke: "#EDF0F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3.83203L16.5 3.83203",
    stroke: "#EDF0F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.83203C4 3.05546 4 2.66718 4.12687 2.36089C4.29602 1.95251 4.62048 1.62806 5.02886 1.4589C5.33515 1.33203 5.72343 1.33203 6.5 1.33203C7.27657 1.33203 7.66485 1.33203 7.97114 1.4589C8.37952 1.62806 8.70398 1.95251 8.87313 2.36089C9 2.66718 9 3.05546 9 3.83203C9 4.6086 9 4.99689 8.87313 5.30317C8.70398 5.71155 8.37952 6.03601 7.97114 6.20516C7.66485 6.33203 7.27657 6.33203 6.5 6.33203C5.72343 6.33203 5.33515 6.33203 5.02886 6.20516C4.62048 6.03601 4.29602 5.71155 4.12687 5.30317C4 4.99689 4 4.6086 4 3.83203Z",
    stroke: "#EDF0F2",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.1641C9 11.3875 9 10.9992 9.12687 10.6929C9.29602 10.2845 9.62048 9.96009 10.0289 9.79093C10.3351 9.66406 10.7234 9.66406 11.5 9.66406C12.2766 9.66406 12.6649 9.66406 12.9711 9.79093C13.3795 9.96009 13.704 10.2845 13.8731 10.6929C14 10.9992 14 11.3875 14 12.1641C14 12.9406 14 13.3289 13.8731 13.6352C13.704 14.0436 13.3795 14.368 12.9711 14.5372C12.6649 14.6641 12.2766 14.6641 11.5 14.6641C10.7234 14.6641 10.3351 14.6641 10.0289 14.5372C9.62048 14.368 9.29602 14.0436 9.12687 13.6352C9 13.3289 9 12.9406 9 12.1641Z",
    stroke: "#EDF0F2",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledFilterIcon);
export default __webpack_public_path__ + "static/media/disabled-filter-icon.6ec51d2d4bafaacb41e5fb9f3c86462d.svg";
export { ForwardRef as ReactComponent };